import { render, staticRenderFns } from "./ConnectionServiceDetail.vue?vue&type=template&id=70f0ffde"
import script from "./ConnectionServiceDetail.vue?vue&type=script&lang=js"
export * from "./ConnectionServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./ConnectionServiceDetail.vue?vue&type=style&index=0&id=70f0ffde&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f0ffde')) {
      api.createRecord('70f0ffde', component.options)
    } else {
      api.reload('70f0ffde', component.options)
    }
    module.hot.accept("./ConnectionServiceDetail.vue?vue&type=template&id=70f0ffde", function () {
      api.rerender('70f0ffde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConnectionServiceDetail.vue"
export default component.exports